module.exports = __webpack_public_path__ + "img/xineiluowen_2.prt.be88e35b.jpg";